import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { requestEventExists } from "services/events/aboutEvents";
import { eventsSessionStorage } from "services/storage/events";

const CheckEventExistence = ({ loadingRequest, children, defaultPath }) => {
	const [eventExists, setEventExists] = useState(null);
	useEffect(() => {
		checkEventExistence();
	}, []);
	const checkEventExistence = async () => {
		const eventId = eventsSessionStorage.eventId.get();
		loadingRequest.show();
		const exists = await requestEventExists(eventId);
		loadingRequest.hide();
		setEventExists(exists);
	};
	if (eventExists === null) return null;
	if (eventExists) return children;
	return (
		<Navigate
			to={defaultPath}
			replace
		/>
	);
};

export default CheckEventExistence;
